import { Dispatch } from 'react';
import { AnyAction } from '@reduxjs/toolkit';
import { setCurrentMaxZoom } from '../../../../../app/redux/slices/currentMaxZoomSlice';
import { mapTileUrlList } from '../mapTileUrlList';

export const maxZoomSetter = (dispatch: Dispatch<AnyAction>, mapTileUrl: string) => {
          mapTileUrl === mapTileUrlList.googleMapsHybrid || 
          mapTileUrl === mapTileUrlList.googleMapsSatellite || 
          mapTileUrl === mapTileUrlList.bingMapSatellite
        ? dispatch(setCurrentMaxZoom(21))
        : mapTileUrl === mapTileUrlList.openStreetMap2 ||
          mapTileUrl === mapTileUrlList.stadiaMap ||
          mapTileUrl === mapTileUrlList.thunderForestTopography
        ? dispatch(setCurrentMaxZoom(20))
        : mapTileUrl === mapTileUrlList.openStreetMap ||
          mapTileUrl === mapTileUrlList.wikiMediaMap ||
          mapTileUrl === mapTileUrlList.googleMapsRoads
        // ? dispatch(setCurrentMaxZoom(19))
        // : mapTileUrl === mapTileUrlList.bingMapSatellite
        ? dispatch(setCurrentMaxZoom(17))
        : mapTileUrl === mapTileUrlList.topographyMap
        ? dispatch(setCurrentMaxZoom(16))
        : dispatch(setCurrentMaxZoom(18));
};
